<main class="about-page">

  <!-- ─── HERO ─── -->
  <section class="about-hero">
    <div class="about-hero-body">
      <span class="about-eyebrow">
        <i class="fas fa-circle-info"></i>
        {{ 'ABOUT_PAGE.TITLE' | translate }}
      </span>

      <h1 class="about-title">
        Atlas
        <span class="about-title-greek">Ἄτλας</span>
      </h1>

      <p class="about-subtitle">{{ 'ABOUT_PAGE.HERO_SUBTITLE' | translate }}</p>
      <p class="about-description">{{ 'ABOUT_PAGE.HERO_DESCRIPTION' | translate }}</p>
    </div>

    <div class="about-hero-media">
      <img src="assets/img/atlas.webp" alt="Atlas" class="about-hero-image" />
    </div>
  </section>

  <!-- ─── MISSIONE ─── -->
  <section class="about-card about-mission">
    <div class="about-section-head">
      <div class="about-section-icon">
        <i class="fas fa-bullseye"></i>
      </div>
      <div class="about-section-head-text">
        <h2 class="about-section-title">{{ 'ABOUT_PAGE.MISSION_TITLE' | translate }}</h2>
        <p class="about-section-subtitle">{{ 'ABOUT_PAGE.PORTAL_TITLE' | translate }}</p>
      </div>
    </div>

    <p class="about-mission-text">{{ 'ABOUT_PAGE.MISSION_TEXT' | translate }}</p>
  </section>

  <!-- ─── FUNZIONALITÀ ─── -->
  <section class="about-features">
    <div class="about-section-head">
      <div class="about-section-icon about-section-icon--neutral">
        <i class="fas fa-layer-group"></i>
      </div>
      <div class="about-section-head-text">
        <h2 class="about-section-title">{{ 'ABOUT_PAGE.FEATURES_TITLE' | translate }}</h2>
        <p class="about-section-subtitle">{{ 'ABOUT_PAGE.FEATURES_INTRO' | translate }}</p>
      </div>
    </div>

    <div class="about-features-grid">
      <article class="about-feature-card" *ngFor="let feature of features">
        <div class="about-feature-icon">
          <i class="fas" [ngClass]="feature.icon"></i>
        </div>
        <h3 class="about-feature-title">{{ feature.titleKey | translate }}</h3>
        <p class="about-feature-desc">{{ feature.descriptionKey | translate }}</p>
      </article>
    </div>
  </section>

</main>
